import { useMutation, useQueryClient } from '@tanstack/react-query';

export default function useSyncCareerBank() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async () => {
      const csrfToken =
        (document.querySelector('meta[name="csrf-token"]') as HTMLMetaElement)?.content || '';
      const response = await fetch('/admin/api/assistant_todos/sync_career_bank', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': csrfToken,
        },
      });
      if (!response.ok) {
        throw new Error('Career Bank同期の開始に失敗しました');
      }
      return response.json();
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['admin', 'assistant_todos'] });
    },
  });
}
